<template>
  <SubContent h="550px" @back="toCancel">
    <template v-slot:nav_left> 编辑优秀苗子信息 </template>
    <div class="page-content">
      <div class="step-box">
        <!-- status: wait / process / finish / error / success -->
        <el-steps
          :active="activeStep"
          finish-status="success"
          process-status="wait"
          simple
        >
          <el-step title="评估信息"></el-step>
          <el-step title="专项评分"></el-step>
          <el-step title="主观评价"></el-step>
        </el-steps>
      </div>
      <div class="form_wrap">
        <vue-scroll>
          <div class="scroll-content form-content" style="margin: 0 20px">
            <el-form
              :inline="false"
              ref="form"
              :model="form"
              label-width="220px"
            >
              <el-form-item
                label="球员特点与创造力"
                prop="qualityAndCreativity"
                :rules="[
                  { required: true, message: '必填项', trigger: 'blur' },
                ]"
              >
                <el-input
                  v-model="form.qualityAndCreativity"
                  type="textarea"
                  class="w380"
                  placeholder="请评价球员特点与创造力"
                  :rows="4"
                  maxlength="200" show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item
                label="其他评价"
                prop="otherComment"
                :rules="[
                  { required: true, message: '必填项', trigger: 'blur' },
                ]"

              >
                <el-input
                  v-model="form.otherComment"
                  type="textarea"
                  class="w380"
                  placeholder="其他评价"
                  :rows="4"
                  maxlength="200" show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="item_title side">
              视频
              <div>
                <span style="cursor: pointer" @click="addMedia">本地上传视频</span>
                <span style="margin: 0 10px">/</span>
                <span style="cursor: pointer" @click="associateMore">从视频库中选择</span>
              </div>
            </div>
            <div class="trainPlan">
              <div
                v-for="(item,index) in videoToPlayerVos"
                :key="index"
                class="mediaDetail"
                @click.stop="goDetail(item.uuid)">
                <div class="img">
                  <img
                    class="playImg"
                    :src="playImg"
                    style="position: absolute;top: 30px;left: 65px;"
                    @click.stop="openVideoDialog(item.videoAddress,item.videoCoverAddress)">
                  <img
                    class="coverImg "
                    :src="item.videoCoverAddress || planImg"
                    alt=""
                    style="width: 170px;height:100px"
                    @error="item.videoCoverAddress === planImg" >
                </div>
                <div class="intro">
                  <p class="p_item">标题：{{item.videoTitle || '--'}}</p>
                  <p class="p_item">上传人：{{item.authorName}}</p>
                  <p >时长： {{filterTime(parseInt(item.videoDuration / 60))}}:{{ filterTime(item.videoDuration % 60)}}</p>
                </div>
              </div>
            </div>
            <yioks-empty v-show="videoToPlayerVos.length === 0" :h="'150px'"></yioks-empty>
          </div>
        </vue-scroll>
        <yioks-tips :showTip="tipsFlag" :tipMsg="tipMsg" :loading="repeatSubmit" @callback="hideTipsDialog"></yioks-tips>
        <yioks-tips :showTip="tipsFlagNext" tipMsg="请确认是否提交优秀苗子推荐，提交过后不可更改？" :loading="repeatNext" @callback="hideTipsDialogNext"></yioks-tips>
        <yioks-tips :showTip="tipsFlagCancel" tipMsg="请确认放弃保存并返回吗？" :loading="repeatSubmitCancel" @callback="hideTipsDialogCancel"></yioks-tips>
        <yioks-tips :showTip="tipsFlagOther" tipMsg="信息提交成功，是否推荐同一场比赛的同一只球队的另一名苗子？" :loading="repeatOther" @callback="hideTipsDialogOther"></yioks-tips>
      </div>
    </div>

    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" @click="preNext">上一步</el-button>
        <el-button type="primary" @click="templateSave">暂时保存</el-button>
        <el-button
          type="primary"
          @click="submitFormData()"
          >提交</el-button
        >
        <el-button type="danger" @click="toCancel">取消</el-button>
      </div>
    </template>
      <addBatch ref="addBatchRef"></addBatch>

    <template v-if="showDialog">
      <associateMore
        :objectUuid="dataUuid"
        :type="link.type"
        :obj="propObj"
        :title="link.title"
        :organUuid="orgInfo.organUuid"
        :youthUuid="orgInfo.youthUuid"
        :showDialog.sync="showDialog"
        mediaType="scout"
        @hideDialog="hideDialog"></associateMore>
    </template>
    <template v-if="showMediaUpload">
      <uploadMedia
        :showTip.sync="showMediaUpload"
        :orgInfo="orgInfo"
        :uuid="propUuid"
        type="scout"
        @hideUploadDialog ="hideUploadDialog"></uploadMedia>
    </template>
    <template v-if="showVideo">
      <el-dialog
        :visible.sync="showVideo"
        width="800px"
        class="linkAllDialog"
        :close-on-click-modal="false"
        top="12vh">
        <div style="text-align: center;background-color: black;width: 760px" >
          <video
            ref="video"
            controls
            width="760"
            autoplay
            disablePictureInPicture
            :poster="poster"
            controlsList = "nodownload noremoteplayback"
            height="400">
            <source :src="videoSrc" type="video/mp4">
          </video>
        </div>
      </el-dialog>

    </template>
  </SubContent>
</template>

<script>
import scout from "@/api/scout";
import player from "@/api/player"; // getPlayerInfo获取球员信息
import storage from "@/utils/storage";
import media from '@/api/media'
import playImg from '@/assets/images/common/playImg.png'
import addBatch from "@/views/scout/addBatch";
export default {
  name: "ScoutRate",

  data() {
    return {
      playImg,
      tipsFlag: false,
      repeatSubmit: false,
      tipsFlagCancel: false,
      tipsFlagOther: false,
      repeatSubmitCancel: false,
      repeatNext: false,
      repeatOther: false,
      tipsFlagNext: false,
      tipMsg:"请确认暂时保存并退出？",
      pre:0,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      activeStep: 3,
      videoToPlayerVos: [],
      showMediaUpload: false,
      showDialog: false,
      form: {
        qualityAndCreativity: "",
        otherComment: "",
        first:false
      },
      propUuid: '',
      orgInfo: {
        organUuid: '',
        organShortName: '',
        youthUuid: '',
        youthShortName: ''
      },
      link: {
        title: '',
        type: ''
      },
      propObj: {},
      videoSrc: '',
      poster: '',
      showVideo: false
    };
  },

  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    'yioks-tips': () => import('@/components/YioksTip'),
    'associateMore': () => import('@/components/associatedDialog/associatedMore'),
    'uploadMedia': () => import('@/views/media/uploadMedia'),
    'addBatch': addBatch
  },
  filters: {
    filterTime (val) {
      return `${parseInt(val / 60)} 小时 ${val % 60} 分`
    }
  },
  computed: {
    playerUuid() {
      const uuid = this.$route.query.playerUuid || "";
      return uuid;
    },

    dataUuid() {
      const uuid = this.$route.query.dataUuid || "";
      return uuid;
    },
  },

  mounted() {
    this.loadScoutDataInfo();
    this.getVideoList();
  },

  methods: {
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    getVideoList () {
      media.videoListToObjectList({
        objectUuid: this.dataUuid
      }).then(res => {
        this.videoToPlayerVos = res
      })
    },
    addMedia () {
      this.propUuid = this.dataUuid
      this.showMediaUpload = true
    },
    associateMore () {
      this.$set(this.link, 'type', 'media')
      this.$set(this.link, 'title', '从视频库中选择')
      this.showDialog = true
    },
    hideDialog (val) {
      this.showDialog = val
      this.getVideoList()
    },
    hideUploadDialog (val) {
      this.showMediaUpload = val
      this.getVideoList()
    },
    openVideoDialog (src, poster) {
      this.videoSrc = src
      this.poster = poster || ''
      this.showVideo = true
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/media/detail',
        query: {
          uuid
        }
      })
    },
    /* 上一步 */
    preNext() {
      this.tipMsg="请确认保存并返回上一步吗？"
      this.pre = 1;
      this.tipsFlag = true
    },
    templateSave () {
      this.pre = 0
      this.tipsFlag = true
    },
    /* 下一步 */
    submitFormData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tipsFlagNext = true
        }
      });
    },
    hideTipsDialogNext (ok) {
      if (ok){
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.repeatNext = true
            this.handleSubmiteData();
            this.repeatNext = false
            this.tipsFlagNext = false
          }
        });
      }
      else {
        this.repeatNext = false
        this.tipsFlagNext = false
      }
    },
    hideTipsDialogOther (ok) {
      if (ok){
        console.log(this.defaultScoutDataInfo)
        this.$set(this.$refs.addBatchRef.batchInfo, "organUuid", this.defaultScoutDataInfo.organUuid)
        this.$set(this.$refs.addBatchRef.batchInfo, "organShortName", this.defaultScoutDataInfo.organShortName)
        this.$refs.addBatchRef.changeBathOrg()
        this.$set(this.$refs.addBatchRef.batchInfo, "youthUuid", this.defaultScoutDataInfo.youthUuid)
        this.$set(this.$refs.addBatchRef.batchInfo, "youthShortName", this.defaultScoutDataInfo.youthShortName)
        this.$refs.addBatchRef.changeBathCenter()
        this.$set(this.$refs.addBatchRef.batchInfo, "squadUuid", this.defaultScoutDataInfo.squadUuid)
        this.$set(this.$refs.addBatchRef.batchInfo, "squadShortName", this.defaultScoutDataInfo.squadShortName)
        this.$refs.addBatchRef.changeTeam(this.defaultScoutDataInfo.squadUuid)
        console.log(this.$refs.addBatchRef.batchInfo)

        this.$refs.addBatchRef.batchAdd = true
      }else{
        this.$router.push({
          name: "ScoutList",
        });
      }
    },
    /* 提交数据 */
    handleSubmiteData() {

      let aimObj = {
        uuid: this.dataUuid,
        ...this.form,
      };
      this.$set(aimObj, "dataStatus", "complete");
      scout
        .postScoutEditInfo(aimObj)
        .then((res) => {
          if (res.code) {
            this.repeatNext = false
            this.tipsFlagNext = false
            this.$message.error(res.msg)
          } else {
            // this.$message.success("信息保存成功！~");
            this.repeatNext = false
            this.tipsFlagNext = false
            this.tipsFlagOther = true

          }
        })
        .catch((err) => {
          this.repeatNext = false
          this.tipsFlagNext = false
          console.log(err);
        });
    },

    hideTipsDialog(ok) {
      if(ok){
        if (!this.repeatSubmit) {
          this.repeatSubmit = true
          let aimObj = {
            uuid: this.dataUuid,
            ...this.form,
          };
          this.$set(aimObj, "dataStatus", "incomplete");
          scout
          .postScoutEditInfo(aimObj)
          .then((res) => {
            this.repeatSubmit = false
            this.tipsFlag = false
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$message.success("信息保存成功！~");
              if (this.pre === 1){
                this.$router.go(-1)
              } else {
                this.$router.push({
                  name: "ScoutList",
                });
              }
            }
          })
          .catch((err) => {
            this.repeatSubmit = false
            this.tipsFlag = false
            console.log(err);
          });
        }
      } else {
        this.repeatSubmit = false
        this.tipsFlag = false
      }

    },

    /* 取消 */
    toCancel() {
      this.tipsFlagCancel = true
    },

    hideTipsDialogCancel (ok) {
      if (ok){
        this.repeatSubmitCancel = false
        this.tipsFlagCancel = false
        this.$router.push({
          name: "ScoutList",
        });
      }else {
        this.repeatSubmitCancel = false
        this.tipsFlagCancel = false
      }
    },
    /* 获取球员信息 */
    loadPlayerInfo() {
      player
        .getPlayerInfo(this.playerUuid)
        .then((res) => {
          const { idName, birthday } = res.user;
          if (idName) this.$set(this.form, "playerName", idName);
          if (birthday) this.$set(this.form, "playerBirthday", birthday);
        })
        .catch((err) => {
          console.error("请求异常", err);
        });
    },

    /* 获取球探报告的默认信息 */
    loadScoutDataInfo() {
      const uuid = this.dataUuid;
      scout
        .getScoutDataInfo(uuid)
        .then((res) => {
          this.defaultScoutDataInfo = res;
          this.orgInfo.youthUuid = res.youthUuid;
          this.orgInfo.youthShortName = res.youthShortName;
          this.orgInfo.organUuid = res.organUuid;
          this.orgInfo.organShortName = res.organShortName;
          const { otherComment, qualityAndCreativity,first } = res;
          this.form = Object.assign({}, this.form, {
            otherComment,
            qualityAndCreativity,
            first
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.form_wrap {
  padding: 20px 20px 60px;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  font-size: 16px;
  height: 500px;
}

.step-box {
  margin-top: 10px;
}

.btn_wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}

.w380 {
  width: 380px;
}

.form-content {
  span.thead {
    height: 40px;
    font-size: 18px;
    font-weight: 600;
    line-height: 40px;
    text-align: center;
  }

  .label-wrapper, .conten-wrapper {
    width: 100%;
  }
  .item_title{
    padding  20px 0
    margin-bottom 20px
    border-bottom 1px solid #FFF
    &.side{
      display flex
      justify-content space-between
    }
  }
  .trainPlan{
    display flex
    justify-content space-between
    flex-wrap wrap
    .planDetail{
      border 1px solid white
      width 100%
      .row{
        min-height 49px
        display flex
        align-items center
        border-bottom 1px solid white
        &:last-child{
          border-bottom none
        }
        .col{
          width:50%
          padding 0 10px 0 20px
          height 100%
          line-height 49px
          text-overflow:ellipsis;
          overflow:hidden;
          white-space:nowrap;
          &:first-child{
            border-right 1px solid white
          }
        }
        .rowLine{
          padding:10px 10px 10px 20px
        }
      }
    }
    .mediaDetail{
      background-color rgba(0, 0, 0, 0.7)
      border 1px solid white
      padding 20px
      width 400px
      display flex
      align-items center
      cursor pointer
      margin-bottom 20px
      .p_item{
        margin-bottom 10px
      }
    }
    .img{
      width 170px
      height 100px
      position relative
      .coverImg{
        width 100%
        height 100%
      }
    }
    .intro{
      padding-left 10px
      width:calc(100% - 170px);
      height 100px
      display flex
      flex-direction column
      justify-content space-between
    }
  }
}

.tr {
  display: flex;
  width: 100%;
  border: 1px solid #fff;
  border-bottom: none;

  &:last-child {
    border-bottom: 1px solid #fff;
  }
}

.td {
  border-right: 1px solid #fff;
  width: 100%;

  &:last-child {
    border-right: none;
  }
}

.sub-tr {
  display: flex;
  width: 100%;
  border-bottom: 1px dashed #fff;
  height: 32px;
  line-height: 32px;

  &:last-child {
    border-bottom: none;
  }
}

.sub-td {
  width: 100%;
  border-right: 1px dashed #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 25px;

  &:last-child {
    border-right: none;
  }
}

.content-text {
  text-indent: 2em;
  height: 24px;
  line-height: 24px;
}

.w240 {
  width: 240px;
}

.w500 {
  width: 500px;
}

.content-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="stylus">
.page-content {
  .el-steps--simple {
    background-color: rgba(0, 0, 0, 0);
  }

  .el-form-item__label {
    color: #fff;
    font-size: 16px;
  }
}
</style>
